import React from "react";
import type { DigiFiCustomer } from "src/types/conditionsInbox";
import { PrimaryButton } from "src/components/Buttons";
import { CardActions, SuccessBadge } from "./SearchSection.styles";

interface CustomerActionsProps {
  disabled: boolean;
  customer: DigiFiCustomer;
  isSent: boolean;
  isCurrentlySending: boolean;
  onSendFiles: (customer: DigiFiCustomer) => void;
  selectedEmailId: string | null;
}

export const CustomerActions: React.FC<CustomerActionsProps> = ({
  disabled,
  customer,
  isSent,
  isCurrentlySending,
  onSendFiles,
  selectedEmailId,
}) => {
  return (
    <CardActions>
      {isSent ? (
        <SuccessBadge>✓ Files Sent</SuccessBadge>
      ) : (
        <PrimaryButton
          onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
            e.stopPropagation();
            onSendFiles(customer);
          }}
          disabled={disabled || isCurrentlySending || !selectedEmailId}
          loading={isCurrentlySending}
        >
          {isCurrentlySending ? "Sending..." : "Send Files"}
        </PrimaryButton>
      )}
    </CardActions>
  );
};
